import { RouteObject } from "react-router";
import SolutionsBasePage from "../pages/SolutionsBasePage.tsx";
import { solutionsNavigationData } from "./solutionsNavigationData.tsx";
import { NavigationList } from "../types/NavigationList.ts";
import Scope3Info from "../pages/Scope3Info.tsx";

const collectKeysWithSolutions = (navigationData: NavigationList): string[] => {
  let keys: string[] = [];

  navigationData.forEach((item) => {
    if (item.solutions) {
      keys.push(item.key);
    }
    if (item.children) {
      keys = keys.concat(collectKeysWithSolutions(item.children));
    }
  });

  return keys;
};

const generateSolutionRoutes = (keys: string[]): RouteObject[] =>
  keys.map((key) => ({
    path: key,
    element: <SolutionsBasePage />, // Use a generic page component
  }));

// Collect keys with solutions
const solutionKeys = collectKeysWithSolutions(solutionsNavigationData);

// Generate routes from the collected keys
export const solutionRoutes = [
  ...generateSolutionRoutes(solutionKeys),
  { path: "scope3", element: <Scope3Info /> }, // scope 3 doesn't match the pattern since it's just a static page
];
